import React from 'react';
import styled from 'styled-components';
import { fonts } from '../themes';

const FontGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
`;

const FontCard = styled.div<{ isSelected: boolean; fontFamily: string }>`
  padding: 20px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid ${props => props.isSelected ? '#667eea' : '#e2e8f0'};
  background: white;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const FontName = styled.h4`
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
`;

const FontPreview = styled.div<{ fontFamily: string }>`
  font-family: ${props => props.fontFamily};
  font-size: 18px;
  color: #4a5568;
  line-height: 1.4;
`;

interface FontSelectorProps {
  selectedFont: string;
  onFontChange: (font: string) => void;
}

const FontSelector: React.FC<FontSelectorProps> = ({ selectedFont, onFontChange }) => {
  const fontOptions = [
    { key: 'clean', name: 'Inter', sample: 'Clean & Professional' },
    { key: 'modern', name: 'Montserrat', sample: 'Modern & Stylish' },
    { key: 'social', name: 'Nunito', sample: 'Social & Friendly' },
  ];

  return (
    <FontGrid>
      {fontOptions.map((font) => (
        <FontCard
          key={font.key}
          isSelected={selectedFont === font.key}
          fontFamily={fonts[font.key as keyof typeof fonts]}
          onClick={() => onFontChange(font.key)}
        >
          <FontName>{font.name}</FontName>
          <FontPreview fontFamily={fonts[font.key as keyof typeof fonts]}>
            Beautiful typography
          </FontPreview>
        </FontCard>
      ))}
    </FontGrid>
  );
};

export default FontSelector;
